import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from '../../hook';
import styles from './styles.module.scss';
import { RootState } from "../../store";
import {toggleDisableOpenMenu, toggleNotifyTinIsInValid} from "../../store/utilsSlice";
import { classnames } from '../../utils';
import axios from "../../api/axios";
import loadingImage from '../../assets/images/loadingImg.gif';

interface LandingCardProps {
    icon?: React.ReactNode;
    title?: string,
    path?: string,
    className?: string,
    size?: "small" | "middle",
    urlFromBe?: boolean,
}

const pathsWithoutTin = [
    '/declaration',
    '/payments',
    '/notifications',
    '/notifications-general',
    '/notifications-iv',
    '/notifications-viv',
    '/tax-balance'
];

const pathsWithInvalidTin = [
    '/declaration',
    '/revenues/other-source',
    '/payments',
    '/notifications',
    '/notifications-general',
    '/notifications-iv',
    '/notifications-viv',
    '/tax-balance'
];

export const LandingCard: React.FC<LandingCardProps> = (props) => {
    const { icon, title, path, className, size, urlFromBe } = props;
    const navigate = useNavigate();
    const auth: any = useSelector((state: RootState) => state.auth);
    const utils: any = useSelector((state: RootState) => state.utils);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const handleClick = () => {
        if(urlFromBe) {
            if(!loading) {
                setLoading(true);
                axios.get(path ?? "")
                    .then((res) => {
                        window.open(res.data.url ?? res.data.taxiAppUrl, '_blank');
                    })
                    .catch((err) => {
                        console.log(err, "-----> error");
                    })
                    .finally(() => {
                        setLoading(false);
                    })
            }
        } 
        else if (!auth.tin && pathsWithoutTin.includes(path as string)) {
            dispatch(toggleDisableOpenMenu(true));
        } else {
            if (auth.tin && !utils.tinIsValid && pathsWithInvalidTin.includes(path as string)) {
                dispatch(toggleNotifyTinIsInValid(true));
                return;
            }
            path && navigate(path);
        }
    };

    const cs = classnames({
        [styles.LandingCard]: true,
        [className as string]: !!className,
        [styles[size ?? ""]]: !!size
    });

    return (
        <div className={cs} onClick={handleClick}>
            {icon && !loading && <div className={styles.Icon}>{icon}</div>}
            <div className={classnames({[styles.Loading]: true, [styles.Show]: loading})}>
                <img src={loadingImage} alt='loading' />
            </div>
            {title && <p className={styles.Title}>{title}</p>}
        </div>
    );
};
